import * as DatasetHelper from '../dataset-helper';

/**
 * Utility method to determine if the value is a scalar or a property. A property value must be
 * encapsulated by '${}'
 */
function isProperty(value) {
  return value && (typeof value === 'string') && value.startsWith('${') && value.endsWith('}');
}

/**
 * Utility method to return the property name from the value.
 */
function getProperty(value) {
  return value.substring(2, value.length - 1);
}

/**
 * Perform {@code Division} based on the configuration.
 */
export default function calculate(statistics, dataset, categoryFieldId, calculationStepDefn) {

  if (calculationStepDefn.result.startsWith('category.')) {

    // Category-level calculation.

    const categoryField = DatasetHelper.findField(dataset, categoryFieldId);
    const categories = categoryField.categories;
    const numOfCategories = categories.length;
    categories.forEach(category => {
      const categoryResult = statistics[category.value];
      if (!categoryResult) {
        throw new Error(`Unable to find category results for \"${category.value}\"`);
      }

      // Identify the nominator.
      let nominatorValue = undefined;
      const nominatorDefn = calculationStepDefn.nominator;
      if (isProperty(nominatorDefn)) {
        // Property.
        const fullPropertyName = getProperty(nominatorDefn);
        const propertyName = fullPropertyName.substring(fullPropertyName.indexOf('.') + 1);
        nominatorValue = (fullPropertyName.startsWith('category.') ?
          categoryResult[propertyName] :
          statistics[propertyName]);
      } else {
        // Scalar.
        nominatorValue = nominatorDefn;
      }

      // Identify the denominator.
      let denominatorValue = undefined;
      const denominatorDefn = calculationStepDefn.denominator;
      if (isProperty(denominatorDefn)) {
        // Property.
        const fullPropertyName = getProperty(denominatorDefn);
        const propertyName = fullPropertyName.substring(fullPropertyName.indexOf('.') + 1);
        denominatorValue = (fullPropertyName.startsWith('category.') ?
          categoryResult[propertyName] :
          statistics[propertyName]);
      } else {
        denominatorValue = denominatorDefn;
      }

      // Assign the result.
      const resultFieldName = calculationStepDefn.result.substring(calculationStepDefn.result.indexOf('.') + 1);
      categoryResult[resultFieldName] = (denominatorValue > 0 ? nominatorValue / denominatorValue : 0.0);

    });

  } else {

    // Field-level calculation.

    // Identify the nominator.
    let nominatorValue = undefined;
    const nominatorDefn = calculationStepDefn.nominator;
    if (isProperty(nominatorDefn)) {
      const fullPropertyName = getProperty(nominatorDefn);
      const propertyName = fullPropertyName.substring(fullPropertyName.indexOf('.') + 1);
      nominatorValue = statistics[propertyName];
    } else {
      nominatorValue = nominatorDefn;
    }

    // Identify the denominator.
    let denominatorValue = undefined;
    const denominatorDefn = calculationStepDefn.denominator;
    if (isProperty(denominatorDefn)) {
      const fullPropertyName = getProperty(denominatorDefn);
      const propertyName = fullPropertyName.substring(fullPropertyName.indexOf('.') + 1);
      denominatorValue = statistics[propertyName];
    } else {
      denominatorValue = denominatorDefn;
    }

    // Assign the result.
    const resultFieldName = calculationStepDefn.result.substring(calculationStepDefn.result.indexOf('.') + 1);
    statistics[resultFieldName] = (denominatorValue > 0 ? nominatorValue / denominatorValue : 0.0);

  }

}


// WEBPACK FOOTER //
// ./src/app/utils/calculators/divide-calculator.js